import type { EffectBuild, QueryEffectBuilds } from "@skilitics/nautilus-core-designer-data";

import type { GetDesignerNodeById } from "../../state/index.ts";
import type { GetNodeEffectBuildables } from "../querying/index.ts";

export type AddEffect = (responseId: number, effect: EffectBuild) => void;

export const addEffectValidatedCreate =
  (
    getById: GetDesignerNodeById,
    queryEffectBuilds: QueryEffectBuilds,
    getEffectBuildables: GetNodeEffectBuildables,
    addEffect: AddEffect,
  ): AddEffect =>
  (responseId, effect) => {
    const { nodeId, buildableName } = effect;
    const existingOfSame = queryEffectBuilds({ type: "byResponseId", responseId }).find(
      (e) => e.nodeId === nodeId && e.buildableName === buildableName,
    );
    if (existingOfSame) {
      const node = getById(nodeId);
      const buildables = getEffectBuildables(node);
      const relevantBuildable = buildables.find((b) => b.name === buildableName);
      if (relevantBuildable?.unique) {
        throw new Error(
          `${buildableName} effect already exists on node ${nodeId} response ${responseId} and it is flagged as unique.`,
        );
      }
    }
    return addEffect(responseId, effect);
  };
